import {
	FileUpload as FileUploadPrimitive,
	FileUploadItemDeleteTriggerProps,
} from '@ark-ui/react/file-upload'
import { LineEdit } from '@qr-front/icons/line-edit'
import { LineEye } from '@qr-front/icons/line-eye'
import { LineTrashAlt } from '@qr-front/icons/line-trash-alt'

import { cn } from '@/utils'

import { buttonCls } from '../Button'

export const FileActions = ({
	onPreview,
	onReplace,
	onDelete,
	deleteButtonLabel,
	showPreviewButton,
	className,
	disabled,
}: {
	onPreview?: () => void
	onReplace: () => void
	onDelete: () => void
	deleteButtonLabel?: string
	showPreviewButton?: boolean
	className?: string
	disabled?: boolean
}) => {
	const previewButton = (
		<div
			role="button"
			className={cn(
				buttonCls({ visual: 'soft', size: 'icon' }),
				disabled && 'pointer-events-none opacity-50',
			)}
			onClick={(event) => {
				event.stopPropagation()
				onPreview?.()
			}}
		>
			<LineEye className="size-4" />
		</div>
	)

	const replaceButton = (
		<div
			role="button"
			className={cn(
				buttonCls({ visual: 'soft', size: 'icon' }),
				disabled && 'pointer-events-none opacity-50',
			)}
			onClick={(event) => {
				if (disabled) return
				event.stopPropagation()
				onReplace()
			}}
		>
			<LineEdit className="size-4" />
		</div>
	)

	const deleteButtonProps: FileUploadItemDeleteTriggerProps = {
		role: 'button',
		disabled,
		onClick: (event) => {
			event.stopPropagation()
			onDelete()
		},
	}

	const deleteButtonSmallDevice = (
		<FileUploadPrimitive.ItemDeleteTrigger
			{...deleteButtonProps}
			className={cn(
				buttonCls({ visual: 'soft', size: 'icon', className: 'tablet:hidden' }),
			)}
		>
			<LineTrashAlt className="size-4" />
		</FileUploadPrimitive.ItemDeleteTrigger>
	)

	const deleteButtonRegular = (
		<FileUploadPrimitive.ItemDeleteTrigger
			{...deleteButtonProps}
			className={cn(
				buttonCls({ visual: 'soft' }),
				'hidden grow gap-2 tablet:flex tablet:grow-0',
			)}
		>
			<LineTrashAlt className="size-4 shrink grow-0" />
			{deleteButtonLabel || null}
		</FileUploadPrimitive.ItemDeleteTrigger>
	)

	return (
		<div
			className={cn(
				'flex w-full justify-end gap-2 tablet:w-[unset]',
				disabled && 'cursor-not-allowed',
				className,
			)}
		>
			{showPreviewButton ? previewButton : null}

			{replaceButton}

			{deleteButtonSmallDevice}
			{deleteButtonRegular}
		</div>
	)
}
